module.exports = __webpack_public_path__ + "static/media/team.dadee168.png";